import React from 'react';
import { Card } from 'semantic-ui-react';
import Job from '../../../models/Job';
import JobCard from './JobCard';

// Jobs arrive pre-sorted by status group and, within the accepted group,
// by meeting time (soonest upcoming first) - see the `groupByStatus` sort
// applied server-side in the `jobs` query. This just wraps each job with
// its derived display status.
const ProjectJobs = ({ project }) => {
  const jobs = project.jobs.map((projectJob) => ({ ...new Job(projectJob), project }));
  return (
    <div className="requests">
      <Card.Group itemsPerRow={2} stackable>
        {jobs.map((job) => <JobCard key={job.id} job={job} />)}
      </Card.Group>
    </div>
  );
};

export default ProjectJobs;
